const baseSize = 16
// 设置 rem 函数
function setRem () {
  // 自适应主机制已由 src/plugins/adaptive.js（html zoom 等比缩放）接管，
  // 此处固定根字号 16px，避免 rem 与 zoom 双重缩放导致尺寸失调。
  document.documentElement.style.fontSize = baseSize + 'px'
}
// 初始化
setRem()
